import Button from '@rio-cloud/rio-uikit/Button';
import Spinner from '@rio-cloud/rio-uikit/Spinner';
import { FormattedMessage } from 'react-intl';

interface Props {
    updateContract: () => void;
    isUpdating: boolean;
}

export const RenewFooterNoRenewal = (props: Props) => {
    const { updateContract, isUpdating } = props;

    return (
        <div>
            <div className={'display-flex justify-content-end margin-bottom-10 margin-top-20'}>
                <span className={'uikit-icon icon-warning-sign margin-right-5'} />
                <FormattedMessage id={'intl-msg:marketplace.contracts.noRenewal.info'} />
            </div>
            <div className='display-flex justify-content-end padding-bottom-20'>
                {isUpdating ? (
                    <Spinner />
                ) : (
                    <Button
                        type='button'
                        className='btn btn-primary'
                        onClick={updateContract}
                        autoTrackingKey='marketplace.contracts.updateRenewal'
                    >
                        <FormattedMessage id={'intl-msg:marketplace.contracts.updateRenewal'} />
                    </Button>
                )}
            </div>
        </div>
    );
};
